import instance from "../config/axios";
import { base_apis } from "../config/url";

export const packList = (data) => {
    return instance.post(`${base_apis.coinStores}/packs/list`, data)
        .then((res) => {
            return res;
        });
};

export const bundleList = (data) => {
    return instance.post(`${base_apis.coinStores}/bundle/list`, data)
        .then((res) => {
            return res;
        });
};


export const avatarList = (data) => {
    return instance.post(`${base_apis.avatar}/list`, data)
        .then((res) => {
            return res;
        });
};

export const purchaseCoin = (data) => {
    return instance.post(`${base_apis.payu}/payment-hash`, data)
        .then((res) => {
            return res;
        });
};

export const createPayment = (data) => {
    return instance.post(`${base_apis.payu}/create-payu-payment`, data)
        .then((res) => {
            return res;
        });
};

export const buyAvatar = (data) => {
    return instance.post(`${base_apis.account}/buy-avatar/${data}`)
        .then((res) => {
            return res;
        });
};